import React, { useState } from "react";
import { motion } from "framer-motion";
import "../styles/splashScreen.css";

const SplashScreen = () => {
  const [showBubbles, setShowBubbles] = useState(true);

  // Hide bubbles after 3 seconds
  setTimeout(() => setShowBubbles(false), 3000);

  return (
    <div className="splash-screen-container">
      <div className="splash-text-wrapper">
        <motion.span
          className="splash-text md"
          initial={{ x: "-100vw" }}
          animate={{ x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          Md
        </motion.span>
        <motion.span
          className="splash-text mall"
          initial={{ x: "100vw" }}
          animate={{ x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
         Mall
        </motion.span>
      </div>
      <motion.div
        className="underline"
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        transition={{ delay: 1, duration: 0.8, ease: "easeInOut" }}
      />
      {/* Show bubbles only for 3 seconds */}
      {showBubbles &&
        Array.from({ length: 15 }).map((_, i) => (
          <div key={i} className="bubble"></div>
        ))}
    </div>
  );
};

export default SplashScreen;
